/**
 * File tương thích cho categoryAttrManager.tsx
 * Sử dụng interface cũ để không phá vỡ code existing
 */
import React from "react";
import EditViewNew from "./editViewNew";
import AttributeFormStore from "../../store/AttributeFormStore";

interface EditViewProps {
  id: number;
  onClose: any;
  load: number;
  // Các props khác có thể có
  forceReloadData?: () => void;
  listTblCategoryAttributeModels?: any[];
  savedAttributeData?: any;
  onSaveTemporary?: any;
  onSaveFinal?: any;
  onApiDataLoaded?: any;
}

const EditView: React.FC<EditViewProps> = ({
  id,
  onClose,
  load,
  forceReloadData,
  ...otherProps
}) => {
  // Tạo store instance riêng cho component này
  const store = AttributeFormStore.getInstance();

  const handleSaveFinal = () => {
    // Logic save tương thích với interface cũ
    if (onClose) {
      onClose(load + 1);
    }
    if (forceReloadData) {
      forceReloadData();
    }
  };

  return <EditViewNew id={id} onSaveFinal={handleSaveFinal} store={store} />;
};

export default EditView;
